import { render, staticRenderFns } from "./AdminSessionNotifications.vue?vue&type=template&id=1aa79ace&scoped=true&"
import script from "./AdminSessionNotifications.vue?vue&type=script&lang=js&"
export * from "./AdminSessionNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AdminSessionNotifications.vue?vue&type=style&index=0&id=1aa79ace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa79ace",
  null
  
)

export default component.exports